module.exports = __webpack_public_path__ + "assets/half-star-color-v2.160499e1.svg";